import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import throttle from 'transmute/throttle';
import useCollaborationSidebarProps from '../../hooks/useCollaborationSidebarProps';
import useCollaborationSidebarState from '../../hooks/useCollaborationSidebarState';
import { useDeepCommentingNavigationMessaging, useSidebarMessageHandlers } from '../messaging/messageHandlers';
export const SidebarMessageHandler = () => {
  "use memo";

  const $ = _c(28);
  const {
    onUpdateCollaborationSidebarState,
    collaborationSidebarState
  } = useCollaborationSidebarState();
  const {
    isOpen: currentIsOpen,
    tab: currentTab
  } = collaborationSidebarState;
  const {
    onScrollToModule,
    onHighLightModuleChange,
    embeddedCommentsProps
  } = useCollaborationSidebarProps();
  let t0;
  let t1;
  if ($[0] !== onUpdateCollaborationSidebarState) {
    t1 = throttle(200, t2 => {
      const {
        isOpen,
        tab
      } = t2;
      return onUpdateCollaborationSidebarState({
        isOpen,
        tab
      });
    });
    $[0] = onUpdateCollaborationSidebarState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  const throttledOpenSidebarWithTab = t0;
  let t2;
  let t3;
  if ($[2] !== onUpdateCollaborationSidebarState) {
    t3 = throttle(200, () => onUpdateCollaborationSidebarState({
      isOpen: false
    }));
    $[2] = onUpdateCollaborationSidebarState;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  t2 = t3;
  const throttledCloseSidebar = t2;
  let t4;
  let t5;
  if ($[4] !== onUpdateCollaborationSidebarState) {
    t5 = throttle(200, tab_0 => onUpdateCollaborationSidebarState({
      tab: tab_0
    }));
    $[4] = onUpdateCollaborationSidebarState;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  t4 = t5;
  const throttledUpdateSidebarTab = t4;
  let t6;
  if ($[6] !== currentIsOpen || $[7] !== currentTab || $[8] !== throttledOpenSidebarWithTab) {
    t6 = t7 => {
      const {
        tab: tab_1
      } = t7;
      if (currentIsOpen && tab_1 === currentTab) {
        return;
      }
      throttledOpenSidebarWithTab({
        isOpen: true,
        tab: tab_1
      });
    };
    $[6] = currentIsOpen;
    $[7] = currentTab;
    $[8] = throttledOpenSidebarWithTab;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== currentIsOpen || $[11] !== throttledCloseSidebar) {
    t7 = () => {
      if (!currentIsOpen) {
        return;
      }
      throttledCloseSidebar();
    };
    $[10] = currentIsOpen;
    $[11] = throttledCloseSidebar;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== currentTab || $[14] !== throttledUpdateSidebarTab) {
    t8 = t9 => {
      const {
        tab: tab_2
      } = t9;
      if (currentTab === tab_2) {
        return;
      }
      throttledUpdateSidebarTab(tab_2);
    };
    $[13] = currentTab;
    $[14] = throttledUpdateSidebarTab;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = {
      onRequestOpenSidebar: t6,
      onRequestCloseSidebar: t7,
      onRequestChangeSidebarTab: t8
    };
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  useSidebarMessageHandlers(t9);
  let t10;
  if ($[20] !== embeddedCommentsProps || $[21] !== onScrollToModule) {
    t10 = msg => {
      onScrollToModule === null || onScrollToModule === void 0 || onScrollToModule(msg.payload.moduleId);
      if (msg.payload.location) {
        var _embeddedCommentsProp;
        embeddedCommentsProps === null || embeddedCommentsProps === void 0 || (_embeddedCommentsProp = embeddedCommentsProps.indicatorNavigateTo) === null || _embeddedCommentsProp === void 0 || _embeddedCommentsProp.call(embeddedCommentsProps, msg.payload.location, msg.payload.moduleId);
      }
    };
    $[20] = embeddedCommentsProps;
    $[21] = onScrollToModule;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== onHighLightModuleChange) {
    t11 = msg_0 => {
      onHighLightModuleChange === null || onHighLightModuleChange === void 0 || onHighLightModuleChange(msg_0.payload.moduleId);
    };
    $[23] = onHighLightModuleChange;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = {
      onRequestScrollToModule: t10,
      onRequestHighlightModule: t11
    };
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  useDeepCommentingNavigationMessaging(t12);
  return null;
};